module.exports = __webpack_public_path__ + "img/loginBg.3c92a18b.jpg";